import { browser } from '$app/environment';

export const setToLocalStorage = <T>(key: string, value: T) => {
  if (browser) {
    const json = JSON.stringify(value);

    localStorage.setItem(key, json);
  }
};
